import { render, staticRenderFns } from "./DrawerPost.vue?vue&type=template&id=523c3341"
import script from "./DrawerPost.vue?vue&type=script&lang=js"
export * from "./DrawerPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523c3341')) {
      api.createRecord('523c3341', component.options)
    } else {
      api.reload('523c3341', component.options)
    }
    module.hot.accept("./DrawerPost.vue?vue&type=template&id=523c3341", function () {
      api.rerender('523c3341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/DrawerPost.vue"
export default component.exports